var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-empty"},[_c('img',{attrs:{"src":_vm.icon,"width":"80px"}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }